:root{
  --bg:#0b1120; --panel:#111a2e; --card:#151f36; --line:#22304d;
  --txt:#e8eefb; --muted:#8fa0bf;
  --acc:#4f7cff; --acc2:#7c5cff;
  --ok:#22c55e; --warn:#f59e0b; --bad:#ef4444;
  --radius:14px;
  --shadow:0 10px 30px rgba(0,0,0,.35);
}
*{box-sizing:border-box;margin:0;padding:0}
html,body,#root{height:100%}
body{
  font-family:"SF Arabic","Segoe UI",Tahoma,system-ui,sans-serif;
  background:var(--bg); color:var(--txt); font-size:15px; line-height:1.6;
  -webkit-font-smoothing:antialiased;
}
a{color:var(--acc);text-decoration:none}
h1{font-size:24px}
h2{font-size:17px;font-weight:600}
h3{font-size:15px}
.muted{color:var(--muted)}
.small{font-size:12.5px}
.center-text{text-align:center}
.ta-c{text-align:center}
.full{width:100%}
.error{color:#fca5a5;background:rgba(239,68,68,.12);border:1px solid rgba(239,68,68,.35);
  padding:9px 12px;border-radius:10px;margin:12px 0;font-size:13.5px}
.req{color:var(--bad)}

/* ---------- buttons ---------- */
.btn{
  border:1px solid var(--line); background:#1b2740; color:var(--txt);
  padding:10px 16px; border-radius:10px; cursor:pointer; font:inherit; font-size:14px;
  display:inline-flex; align-items:center; justify-content:center; gap:6px;
  transition:.15s; white-space:nowrap;
}
.btn:hover{background:#243352; transform:translateY(-1px)}
.btn:active{transform:none}
.btn:disabled{opacity:.6; cursor:not-allowed; transform:none}
.btn-primary{background:linear-gradient(135deg,var(--acc),var(--acc2)); border-color:transparent; font-weight:600}
.btn-primary:hover{filter:brightness(1.1)}
.btn-danger{background:rgba(239,68,68,.14); border-color:rgba(239,68,68,.4); color:#fca5a5}
.btn-sm{padding:6px 11px; font-size:12.5px}

/* ---------- form ---------- */
.field{display:block; margin-bottom:14px}
.field-label{display:block; font-size:13px; color:var(--muted); margin-bottom:6px}
.hint{display:block; color:var(--muted); font-size:11.5px; margin-top:4px; opacity:.8}
input,select,textarea{
  width:100%; padding:11px 13px; background:#0d1526; border:1px solid var(--line);
  border-radius:10px; color:var(--txt); font:inherit; font-size:14.5px; transition:.15s;
}
input:focus,select:focus,textarea:focus{outline:none; border-color:var(--acc); box-shadow:0 0 0 3px rgba(79,124,255,.18)}
textarea{resize:vertical}
select{cursor:pointer}
.mini-select{width:auto; padding:6px 10px; font-size:13px; border-radius:8px}

.seg{display:flex; gap:8px}
.seg button{
  flex:1; display:flex; align-items:center; justify-content:center; gap:7px;
  padding:11px; border-radius:10px; border:1px solid var(--line);
  background:#0d1526; color:var(--muted); cursor:pointer; font:inherit; transition:.15s;
}
.seg button:hover{border-color:var(--acc)}
.seg button.on{background:rgba(79,124,255,.15); border-color:var(--acc); color:var(--txt); font-weight:600}

/* ---------- shell / sidebar ---------- */
.shell{display:flex; min-height:100%}
.side{
  width:250px; flex-shrink:0; background:var(--panel); border-inline-end:1px solid var(--line);
  padding:20px 16px; display:flex; flex-direction:column; gap:20px;
  position:sticky; top:0; height:100vh;
}
.side-brand{display:flex; gap:11px; align-items:center}
.side-logo{font-size:26px}
.side-brand b{display:block; font-size:15px}
.side-nav{display:flex; flex-direction:column; gap:6px; flex:1}
.side-nav button{
  text-align:start; padding:11px 14px; border-radius:10px; border:1px solid transparent;
  background:transparent; color:var(--muted); cursor:pointer; font:inherit; font-size:14.5px; transition:.15s;
}
.side-nav button:hover{background:#1a2540; color:var(--txt)}
.side-nav button.on{background:linear-gradient(135deg,var(--acc),var(--acc2)); color:#fff; font-weight:600}
.side-foot{display:flex; flex-direction:column; gap:8px}
.side-foot a.btn{text-decoration:none}

.content{flex:1; padding:26px 30px; max-width:1200px}
.page-head{display:flex; align-items:center; justify-content:space-between; margin-bottom:20px}
.sub{margin:22px 0 12px; padding-top:16px; border-top:1px dashed var(--line); color:var(--muted)}

/* ---------- cards / table ---------- */
.card{background:var(--card); border:1px solid var(--line); border-radius:var(--radius);
  padding:20px; margin-bottom:18px; box-shadow:var(--shadow)}
.card-head{display:flex; align-items:center; justify-content:space-between; margin-bottom:16px}
.table-wrap{overflow-x:auto}
table{width:100%; border-collapse:collapse; font-size:14px}
th,td{padding:11px 10px; text-align:start; border-bottom:1px solid var(--line)}
th{color:var(--muted); font-size:12.5px; font-weight:600; text-transform:none}
tbody tr:hover{background:#182340}
.link{word-break:break-all}
.actions{display:flex; gap:6px}

.row-form{display:grid; grid-template-columns:2fr 1.5fr auto; gap:12px; align-items:end}
.row-form .field{margin-bottom:0}
.align-end{margin-bottom:1px}
.grid-2{display:grid; grid-template-columns:1fr 1fr; gap:0 14px}
.form-foot{display:flex; gap:10px; align-items:center}
.ok-note{background:rgba(34,197,94,.12); border:1px solid rgba(34,197,94,.4); color:#4ade80;
  padding:11px 14px; border-radius:10px; margin-bottom:16px; font-size:14px}
.ok-note-actions{display:flex; align-items:center; justify-content:space-between; gap:12px; flex-wrap:wrap}

/* ---------- quick report ---------- */
.qr-hint{
  background:rgba(79,124,255,.1); border:1px solid rgba(79,124,255,.28);
  color:#c5d4ff; padding:11px 14px; border-radius:10px; margin-bottom:16px; font-size:13.5px;
}
.qr-hint b{color:#fff}
.qr-step{margin-bottom:16px}
.qr-step-label{font-size:13px; color:var(--muted); margin-bottom:8px; font-weight:600}
.target-picks{display:grid; grid-template-columns:1fr 1fr; gap:10px}
.target-pick{
  text-align:start; padding:12px 14px; border-radius:12px; border:1px solid var(--line);
  background:#0d1526; color:var(--txt); cursor:pointer; font:inherit; display:flex;
  flex-direction:column; gap:4px; transition:.15s;
}
.target-pick:hover{border-color:var(--acc)}
.target-pick.on{background:rgba(79,124,255,.15); border-color:var(--acc)}
.target-pick b{font-size:14px}
.linkish{word-break:break-all; direction:ltr; text-align:left}
.reason-chips{display:flex; flex-wrap:wrap; gap:8px; margin-bottom:10px}
.chip{
  padding:8px 14px; border-radius:999px; border:1px solid var(--line);
  background:#0d1526; color:var(--muted); cursor:pointer; font:inherit; font-size:13.5px; transition:.15s;
}
.chip:hover{border-color:var(--acc); color:var(--txt)}
.chip.on{background:rgba(79,124,255,.18); border-color:var(--acc); color:var(--txt); font-weight:600}
.reason-preview{
  background:#0d1526; border:1px dashed var(--line); border-radius:10px;
  padding:10px 12px; margin:0 0 4px;
}
.reason-box{
  min-height:220px; font-size:15px; line-height:1.7; resize:vertical;
}
.extra-toggle{
  background:none; border:none; color:var(--muted); cursor:pointer; font:inherit;
  font-size:13px; text-align:start; padding:4px 0 12px; width:fit-content;
}
.extra-toggle:hover{color:var(--txt)}
.qr-summary{margin:0 0 12px}
.stack{max-height:220px; overflow:auto; background:#0d1526; border:1px solid var(--line);
  border-radius:10px; padding:12px; font-size:11.5px; direction:ltr; text-align:left;
  color:#fca5a5; white-space:pre-wrap; margin-bottom:16px}

.filters{display:grid; grid-template-columns:160px 160px 1fr auto; gap:10px; margin-bottom:16px}
.filters .btn{white-space:nowrap}

/* ---------- stats ---------- */
.stats{display:grid; grid-template-columns:repeat(auto-fit,minmax(120px,1fr)); gap:12px; margin-bottom:18px}
.stat{background:var(--card); border:1px solid var(--line); border-radius:12px; padding:14px; text-align:center}
.stat span{display:block; color:var(--muted); font-size:12px}
.stat b{font-size:24px; display:block; margin-top:2px}
.t-total{color:var(--txt)} .t-info{color:#7cb0ff} .t-warn{color:#fcd34d}
.t-ok{color:#4ade80} .t-bad{color:#fca5a5} .t-fb{color:#7cb0ff} .t-gg{color:#fcd34d}

/* ---------- request item ---------- */
.req{background:#111b30; border:1px solid var(--line); border-radius:12px; padding:15px; margin-bottom:12px}
.req-top{display:flex; gap:9px; align-items:center; flex-wrap:wrap}
.req-id{font-weight:700; color:var(--muted)}
.req-body{margin:11px 0; white-space:pre-wrap; color:var(--txt)}
.req-foot{display:flex; align-items:center; justify-content:space-between; gap:10px; flex-wrap:wrap}

/* ---------- badges ---------- */
.badge{padding:3px 10px; border-radius:999px; font-size:12px; background:#1e2b45; color:var(--muted); white-space:nowrap}
.badge-ok{background:rgba(34,197,94,.16); color:#4ade80}
.badge-warn{background:rgba(245,158,11,.16); color:#fcd34d}
.badge-bad{background:rgba(239,68,68,.16); color:#fca5a5}
.badge-info{background:rgba(79,124,255,.16); color:#93b4ff}
.badge-fb{background:rgba(59,130,246,.16); color:#7cb0ff}
.badge-gg{background:rgba(234,179,8,.16); color:#fcd34d}
.badge-neutral{background:#1e2b45}

/* ---------- misc ---------- */
.empty{text-align:center; color:var(--muted); padding:34px 10px}
.center{text-align:center; padding:26px}
.spin{display:inline-block; width:22px; height:22px; border:3px solid var(--line);
  border-top-color:var(--acc); border-radius:50%; animation:sp .7s linear infinite}
@keyframes sp{to{transform:rotate(360deg)}}

.toast{position:fixed; bottom:22px; inset-inline-end:22px; z-index:50;
  display:flex; align-items:center; gap:12px; padding:12px 16px; border-radius:12px;
  background:var(--card); border:1px solid var(--line); box-shadow:var(--shadow); font-size:14px;
  animation:up .25s ease}
.toast-ok{border-color:rgba(34,197,94,.5)}
.toast-bad{border-color:rgba(239,68,68,.5)}
.toast button{background:none; border:none; color:var(--muted); cursor:pointer; font-size:15px}
@keyframes up{from{transform:translateY(14px); opacity:0}}

/* ---------- auth / report pages ---------- */
.auth-page{min-height:100vh; display:flex; align-items:center; justify-content:center; padding:24px;
  background:radial-gradient(1000px 500px at 50% -10%, rgba(79,124,255,.14), transparent)}
.auth-card{width:100%; max-width:430px; background:var(--card); border:1px solid var(--line);
  border-radius:18px; padding:30px; box-shadow:var(--shadow)}
.auth-card.wide{max-width:520px}
.auth-logo{font-size:34px; text-align:center; margin-bottom:8px}
.auth-card h1{text-align:center; font-size:22px; margin-bottom:4px}
.auth-card > .muted{text-align:center; margin-bottom:22px; font-size:13.5px}
.auth-card form{margin-top:6px}

@media (max-width:900px){
  .shell{flex-direction:column}
  .side{width:100%; height:auto; position:static; flex-direction:row; flex-wrap:wrap; align-items:center;
    gap:12px; border-inline-end:none; border-bottom:1px solid var(--line)}
  .side-nav{flex-direction:row; flex-wrap:wrap; flex:1 1 100%}
  .side-foot{flex-direction:row}
  .row-form,.filters,.grid-2,.target-picks{grid-template-columns:1fr}
  .content{padding:18px}
}